module.exports = __webpack_public_path__ + "img/crm_banner4.11b4261b.png";